import React, { HTMLAttributes, useEffect, useState } from 'react';
import { InputNumber } from '@meitu/saas-ui';
import LabelAction from '@/components/label-action';
import { useEditor } from '@/hooks/use-editor';
import { useLocaleStore } from '@/i18n';
import './index.less';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    id: string;
    size: { width: number | null; height: number | null } | null;
    onSize?: () => void;
}
const BatchSizeInspector: React.FC<IProps> = ({ id, size, onSize }) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();
    const [width, setWidth] = useState<number | null>(null);
    const [height, setHeight] = useState<number | null>(null);

    useEffect(() => {
        setWidth(size?.width ?? null);
        setHeight(size?.height ?? null);
    }, [size]);

    const handleSize = (
        key: 'width' | 'height',
        val: number | null,
        options: { writeHistory: boolean; isStart: boolean },
    ) => {
        if (val === null) return;

        editor.layer.modifyBasicProperties.batchSize(
            id,
            { [key]: val } as {
                width: never;
                height: number;
            },
            options,
        );
    };

    return (
        <div className="c-base-toolbar-controller">
            <LabelAction title={$t((v) => v.baseToolbar.size)} align>
                <InputNumber
                    v2
                    style={{ width: 73, marginRight: 4 }}
                    value={width}
                    step={1}
                    min={0}
                    showStepBtn={false}
                    shouldReserveValueUndefinedOrNull={true}
                    enableMouseWheel={false}
                    onChangeAfter={(val) => {
                        handleSize('width', val, { writeHistory: true, isStart: false });
                        onSize?.();
                    }}
                    suffix={$t((v) => v.baseToolbar.width)}
                />

                <InputNumber
                    v2
                    style={{ width: 73 }}
                    value={height}
                    step={1}
                    min={0}
                    showStepBtn={false}
                    enableMouseWheel={false}
                    shouldReserveValueUndefinedOrNull={true}
                    onChangeAfter={(val) => {
                        handleSize('height', val, { writeHistory: true, isStart: false });
                        onSize?.();
                    }}
                    suffix={$t((v) => v.baseToolbar.height)}
                />
            </LabelAction>
        </div>
    );
};
export default React.memo(BatchSizeInspector);
